import * as Reducers from './signing-room.reducer';
import * as MetaReducers from './signing-room.metareducer';

export const SigningRoomReducers = { Reducers, MetaReducers };
